import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { logoutUser as serviceLogoutUser } from '../../services/auth';
import { useAuth } from '../../context/AuthContext';

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Logout = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { logoutContext } = useAuth();

  const handleLogout = async () => {
    setLoading(true);
    try {
      await logoutContext();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      logoutContext();
      navigate('/');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LogoutButton onClick={handleLogout} disabled={loading}>
      {loading ? 'Logging out...' : 'Logout'}
      <i className="fas fa-sign-out-alt"></i>
    </LogoutButton>
  );
};

export default Logout; 